<section>
  <app-input-code
    *ngIf="control"
    [control]="control"
    [numberOfChar]="6"
    [password]="true"
  ></app-input-code>
</section>
